export default __webpack_public_path__ + "media/images/services/service-08-370x250-2954b63a7439d7ab78a74e686a5c5901.jpg";